export default "__VITE_ASSET__ZGe27n03__"